{
  "401": {
    "title": "Erreur d'authentification",
    "description": "Nous sommes désolés, mais la page que vous recherchez est actuellement indisponible. L’accès à NTU n’est pas autorisé sans rôle attribué, veuillez contacter votre administrateur."
  },
  "500": {
    "title": "Erreur technique",
    "description": "Une erreur temporaire nous empêche d'afficher cette page. Veuillez réessayer dans quelques instants.",
    "retry": "Réessayer"
  },
  "files": "Documents",
  "attendees_list": "Liste d'invités",
  "attendees": "Invités",
  "attachments": "Pièces jointes",
  "attendee_attachments": "Pièces jointes - Invités",
  "enable": "Activer",
  "disable": "Désactiver",
  "selected": "sélectionné(s)",
  "products": "Produits",
  "regions": "Régions",
  "sectors": "Secteurs",
  "zones": "Zones",
  "identities": "Entités",
  "ugas": "UGAS",
  "networks": "Réseaux",
  "therapeuticAreas": "Aires thérapeutiques",
  "units": "Services",
  "contacts": "Contacts",
  "specialties": "Spécialités",
  "internal_signers": "Signataires internes",
  "users": "Utilisateurs",
  "attachments_template": "Modèles de pièces jointes",
  "admin": "Administration",
  "logout": "Déconnexion",
  "none": "Aucun",
  "profile": "Profil",
  "save": "Sauvegarder",
  "undo": "Précédent",
  "clear_canvas": "Effacer",
  "step_number": "Etape {number}",
  "warning": "Attention !",
  "error": "Erreur",
  "delete": "Supprimer",
  "next": "Suivant",
  "cancel": "Annuler",
  "clone": "Dupliquer",
  "clone_modal": {
    "title": "Dupliquer le ticket",
    "description": "Sélectionnez les données supplémentaires à dupliquer :",
    "indications_default": "Les informations de la section « Indications » seront dupliquées par défaut.",
    "inputs": {
      "packages": "Packages",
      "attendees": "Invités",
      "attachments": "Pièces jointes",
      "packages_assignations": "Packages assignés"
    }
  },
  "trash_modal": {
    "title": "Confirmation d'annulation",
    "description": "Êtes-vous sûr de vouloir supprimer le dossier:",
    "button": "Confirmer l'annulation"
  },
  "clear": "Réinitialiser",
  "apply": "Appliquer",
  "validate": "Valider",
  "to_edit": "Édition",
  "edit": "Éditer",
  "no_data": "Pas de données",
  "select_all": "Tout sélectionner",
  "remove_all": "Tout retirer",
  "results": "résultat",
  "no_results": "Aucun résultat",
  "result": "résultat",
  "archived": "Archiver",
  "add": "Ajouter",
  "modify": "Modifier",
  "assign": "Attribuer",
  "backward": "Retour en arrière",
  "on": "sur",
  "contract": "Contrat",
  "document": "Document",
  "create_and_save": "Créer et enregistrer",
  "to_save": "Enregistrer",
  "drag_and_drop_statement": "Veuillez sélectionner un fichier ou le drag and drop ici",
  "no_elements": "Aucun élément",
  "back_to_home": "Retourner au dashboard",
  "back_to_edit": "Retourner à l'édition",
  "back_to_deposit_management": "Retourner à la gestion des dépôts",
  "selected_entity_placeholder": {
    "attendee": "invité(s)"
  },
  "errors": {
    "401": {
      "title": "Erreur d'authentification",
      "content": "Votre session a expiré, veuillez vous reconnecter."
    },
    "403": "Vous n'avez pas les droits pour accéder à cette page"
  },
  "search": {
    "placeholder": {
      "users": "Rechercher un utilisateur"
    },
    "search_in": "Je recherche dans",
    "one": "un/une",
    "result_by": {
      "label": "Résultat de la recherche sur {by}",
      "contact": "les contacts",
      "veeva": "Veeva",
      "health_directory": "l'ANS",
      "one_key": "One Key"
    }
  },
  "not_found": {
    "title": "Ressource indisponible",
    "description": "Nous sommes désolés, mais la page que vous recherchez est actuellement indisponible. Il se peut qu'elle ait été déplacée, supprimée ou que l'URL soit incorrecte. Veuillez vérifier l'adresse et réessayer.",
    "redirect": "Revenir à la page précédente"
  },
  "modal": {
    "button": {
      "close": "Fermer"
    }
  },
  "select": {
    "placeholder": "Sélectionner une option",
    "disabled": "Option désactivée",
    "na": "N/A",
    "groups": {
      "enabled": "Actifs",
      "disabled": "Inactifs"
    }
  },
  "button": {
    "add": "Ajouter",
    "add_attendee_list": "Téléverser la liste des invités",
    "download_attendee_template": "Télécharger le template"
  },
  "loader_text": {
    "contract_template": {
      "immediate": "Téléversement en cours",
      "indeterminate": {
        "waiting_server": "En attente du serveur",
        "compression": "Compression du fichier",
        "connecting": "Connexion au serveur"
      }
    },
    "expense_report": {
      "immediate": "Téléversement en cours",
      "indeterminate": {
        "waiting_server": "En attente du serveur",
        "compression": "Compression du fichier",
        "connecting": "Connexion au serveur"
      }
    },
    "signing_sheet": {
      "immediate": "Téléversement en cours",
      "indeterminate": {
        "waiting_server": "En attente du serveur",
        "compression": "Compression du fichier",
        "connecting": "Connexion au serveur"
      }
    },
    "non_compliance": {
      "immediate": "Ajout en cours",
      "indeterminate": {
        "waiting_server": "En attente du serveur",
        "compression": "Compression du fichier",
        "connecting": "Connexion au serveur"
      }
    },
    "default": "Chargement en cours"
  },
  "dashboard": {
    "title": "Bienvenue sur votre",
    "declaration_space": "Tableau de bord",
    "create_event": "Créer une manifestation",
    "back_to_dashboard": "Retour au tableau de bord",
    "type": {
      "list": "Liste",
      "column": "Colonne"
    },
    "list_header": {
      "name": "Nom",
      "event_type": "Type",
      "contractor": "Contractant",
      "operation": "Opération",
      "start_at_end_at": "Dates",
      "code": "Référence",
      "created_by": "Créateur",
      "initiator": "Initiateur",
      "validator_1": "Validateur 1",
      "validator_2": "Validateur 2",
      "action": "Action",
      "regime": "Régime",
      "remaining_days": "Délai"
    },
    "status": {
      "creating": "En cours de création",
      "to_edit": "À modifier",
      "canceled": "Annulé"
    },
    "workflow_step": {
      "creating": "En cours de création",
      "to_edit": "À modifier",
      "first_validation": "Première validation",
      "second_validation": "Deuxième validation",
      "validating": "En cours de validation",
      "contract_management": "En cours de soumission & gestion",
      "event_in_progress": "Évènement en cours",
      "event_validating": "Validation dépenses",
      "event_is_finished": "Évènement terminé",
      "library": "Bibliothèque",
      "transparency": "Transparence santé",
      "canceled": "Annulé"
    },
    "workflow": {
      "first_validation": "Première validation",
      "second_validation": "Deuxième validation",
      "contract_management_stage": "Gestion du contrat",
      "event_in_progress": "Évènement en cours",
      "event_validating": "Validation dépenses",
      "event_is_finished": "Évènement terminé"
    },
    "filters": {
      "title": "Filtrer",
      "status": "Statut",
      "apply": "Appliquer",
      "reset": "Effacer",
      "pending_action": "Actions en attente",
      "my_tickets": "Je suis le créateur",
      "my_tickets_to_validate": "Je suis le validateur",
      "show": "Afficher les filtres",
      "hide": "Masquer les filtres"
    },
    "ticket": {
      "contracts": "{signed_contracts}/{eligible_attendees_count} contrats signés",
      "generated_contracts": "{generated_contracts}/{eligible_attendees_count} contrats générés",
      "deposits": "{deposit_sent}/{eligible_deposits_count} dépôts envoyés",
      "advantage": {
        "completed": "Dépenses complétées",
        "not_validated": "Dépenses non validées"
      }
    }
  },
  "library": {
    "title": "Bibliothèque",
    "to_declare": "Transparence Santé",
    "remove_selected_ticket": "Supprimer la sélection",
    "management": "Gestion",
    "ticket_management": "Gestion de la bibliothèque",
    "reports": "Rapports"
  },
  "sidebar": {
    "cta": "Créer une manifestation",
    "collapse": "Masquer la barre latérale",
    "sections": {
      "tickets": "Tickets"
    },
    "links": {
      "contract_management": "Gestion des contrats",
      "dashboard": "Tableau de bord",
      "library": "Bibliothèque",
      "library_to_declare": "Transparence Santé",
      "deposit_list": "Dépôts",
      "ticket_informations": "Informations ticket",
      "ticket_history": "Historique",
      "ticket_additional_costs": "Frais annexes",
      "to_edit_advantages": "Édition avantages",
      "signing": "Signature",
      "signing_sheet": "Feuille d'émargement",
      "non_compliance": "Non Conformité",
      "expenses": "Justificatifs",
      "deposit": "Dépôt",
      "deposit_infos": "Informations dépôt",
      "upsell_dqc": "Analytique"
    },
    "space_name": "Espace {name}"
  },
  "roles": {
    "label": "Rôles",
    "initiator": "Initiateur",
    "validator-1": "Validateur 1",
    "validator-2": "Validateur 2",
    "admin": "Admin (déprécié)",
    "analytics-admin": "Admin analytique",
    "contact-admin": "Admin contact",
    "super-admin": "Super admin",
    "ticket-admin": "Admin manifestation",
    "user-admin": "Admin utilisateur",
    "declaration-admin": "Admin déclarations simplifiées",
    "admin-analytics-dqc": "Admin DQC utilisateur",
    "admin-analytics-dqc-editor": "Admin DQC éditeur",
    "admin-analytics-dqc-manager": "Admin DQC manager",
    "conventions-admin": "Admin conventions simplifiées"
  },
  "inputs": {
    "types": {
      "select": "Select menu",
      "checkbox": "Checkbox"
    },
    "ticket_name": {
      "label": "Nom de l'évènement"
    },
    "internal_tracking_code_name": {
      "label": "Code interne"
    }
  },
  "filter": "Filtre",
  "list": {
    "no_result": "Aucun résultat correspondant"
  },
  "analytics": {
    "error": "Vos données s'afficheront ici",
    "bi": {
      "title": "Analytique - BI",
      "tabs": {
        "dashboard": "Général",
        "performance": "Performances",
        "alert": "Alertes",
        "comparative_analysis": "Analyses comparatives"
      }
    }
  },
  "submissions": {
    "title": "Soumissions"
  },
  "workflow_step_and_status": {
    "creating": "En cours de création",
    "first_validation": "Première validation",
    "second_validation": "Deuxième validation",
    "to_edit": "À modifier",
    "validating": "En cours de validation",
    "contract_management": "En cours de soumission & gestion",
    "event_in_progress": "Évènement en cours",
    "event_validating": "Validation dépenses",
    "event_is_finished": "Évènement terminé",
    "canceled": "Annulé"
  },
  "access_denied": "Accès refusé",
  "items": "éléments",
  "properties": "Propriétés"
}
